<template>
  <div v-swiper:mySwiper="swiperOption">
    <div id="Slider-selector"></div>
    <div class="sliderText">
      <img src="@/assets/logos/logo_GLF-white.svg" alt="Globe Life Field" />
      <div class="titleSection">
        <h2>{{ sliderImages[0].title }}</h2>
        <span>{{ sliderImages[0].subTitle }}</span>
      </div>
      <div class="line-break"></div>
      <p class="slider-desc">{{ sliderImages[0].desc }}</p>
      <!-- <div
        v-if="windowWidth > 1130 || (windowWidth < 1090 && windowWidth > 400)"
        class="line-break"
        id="big-line-break"
      ></div> -->
      <!-- <div class="sliderLinks">
        <div class="sliderLink" id="sliderLink1">
          <img
            class="stars"
            src="@/assets/icons/icon_stars-line.svg"
            alt="Stars"
            id="star1"
          />
          <h4>THE <span class="lowest">LOWEST</span> PRICES OF THE SEASON!</h4>
          <img
            class="stars"
            src="@/assets/icons/icon_stars-line.svg"
            alt="Stars"
            id="star2"
          />
        </div>
        <div class="sliderLink" id="sliderLink2">
          <div class="link-line-break"></div>
          <div id="link2-text">
            <h3>GET TICKETS FROM JUST $9!</h3>
            <p class="link-desc">
              Enjoy Early Bird Pricing when you book your group or place your
              deposit before <u><strong>January 1</strong></u> and you’ll save
              25%.
            </p>
          </div>
          <div class="link-line-break"></div>
        </div>
      </div> -->
    </div>
    <div class="swiper-wrapper" id="swiper-header">
      <div
        class="swiper-slide"
        :key="'SliderImage' + sliderImg.imgNum"
        v-for="sliderImg in sliderImages"
      >
        <img :src="require(`@/assets/images/${sliderImg.imgSrc}`)" />
        <div v-if="!isMobile" class="sliderCaption">
          <p>{{ sliderImg.caption }}</p>
          <!-- <div class="caption-line"></div> -->
        </div>
        <div v-if="!isMobile" class="vignette vignette-left"></div>
        <div v-if="!isMobile" class="vignette vignette-right"></div>
        <div v-if="isMobile" class="blue-overlay"></div>
      </div>
    </div>
    <div
      v-if="!isMobile"
      class="swiper-pagination swiper-pagination-white"
    ></div>
    <div
      v-if="!isMobile"
      class="swiper-button-prev swiper-button-white"
      slot="button-prev"
    ></div>
    <div
      v-if="!isMobile"
      class="swiper-button-next swiper-button-white"
      slot="button-next"
    ></div>
  </div>
</template>

<script>
export default {
  name: "HeroSlider",
  props: {
    sliderImages: {
      type: Array,
    },
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 1,
        spaceBetween: 0,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      windowWidth: window.innerWidth,
    };
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    onResize() {
      this.windowWidth = window.innerWidth;
    },
  },
  computed: {
    isMobile() {
      return this.windowWidth <= 992;
    },
  },
};
</script>

<style lang="scss" scoped>
.swiper-container {
  height: calc(100vw / 16 * 8);
  width: 100vw;
  @media only screen and (max-width: 1090px) {
    height: calc(90vh);
  }
  @media only screen and (max-width: $sm) {
    height: calc(90vh);
  }

  .sliderText {
    // Large
    @media only screen and (max-width: 1320px) {
      width: 50%;
    }
    // Mobile
    @media only screen and (max-width: 1090px) {
      width: 100%;
      -webkit-backdrop-filter: blur(0px);
      backdrop-filter: blur(0px);
    }
    // Desktop
    // center vertical and horizontal
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 10;
    transform: translate(-50%, -50%);
    // flex
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    // display
    height: 100%;
    width: 40%;
    // background
    background-image: linear-gradient(
      180deg,
      rgba(170, 170, 170, 0.2),
      rgba(150, 150, 150, 0.2)
    );
    -webkit-backdrop-filter: blur(10px);
    backdrop-filter: blur(10px);
    // child styles
    color: #fff;
    img {
      margin: 10% 0 5%;
      @media only screen and (min-width: $xl) {
        margin: 20% 0 5%;
      }
      @media only screen and (max-width: 1320px) {
        margin: 12% 0 1%;
      }
      @media only screen and (max-width: 1090px) {
        margin: 12% 0 1%;
      }
      @media only screen and (max-width: $md) {
        margin: 15% 0 5%;
      }
    }
    .titleSection {
      font-family: "BertholdCondensed";
      font-size: 92px;
      line-height: 74px;
      h2 {
        font-size: 92px;
        font-weight: 700;
        margin: 0;
        line-height: 74px;
      }
    }
    .line-break {
      background-color: #fff;
      width: 70px;
      height: 2px;
      margin: 2% 0 0;
    }
    #big-line-break {
      position: absolute;
      bottom: 285px;
      width: 90%;
      margin: 0 0 2%;
      @media only screen and (max-width: 1370px) {
        bottom: 260px;
      }
      @media only screen and (max-width: $md) {
        bottom: 300px;
      }
    }
    .slider-desc {
      padding: 5% 10%;
      font-size: 16px;
      font-weight: 500;
      @media only screen and (min-width: 1578px) {
        font-size: 20px;
        padding: 5% 20%;
      }
      @media only screen and (max-width: $xl) {
        padding: 2% 10%;
        font-size: 16px;
      }
      @media only screen and (min-width: $lg) and (max-width: 1100px) {
        padding: 2% 20%;
        font-size: 16px;
      }
      @media only screen and (max-width: $lg) {
        padding: 5% 15%;
        font-size: 20px;
        margin-top: 5%;
        line-height: 40px;
      }
      @media only screen and (max-width: $md) {
        padding: 5% 10%;
        font-size: 20px;
        margin-top: 5%;
        line-height: 40px;
      }
      @media only screen and (max-width: $sm) {
        padding: 5% 10%;
        font-size: 16px;
        margin-top: 0;
        line-height: 1.5;
      }
      @media only screen and (min-width: 1440px) {
        //font-size: 20px;
        //padding: 5% 20%;
      }
    }

    .sliderLinks {
      // Mobile
      @media only screen and (max-width: $md) {
        flex-direction: column;
        //align-content: center;
        background-image: url("~@/assets/images/img_lowest-prices-overlay.png"),
          linear-gradient(to bottom, #fff 50%, #c10230 50%);
        bottom: 0px;
      }

      //style
      //margin-top: auto;
      @media only screen and (min-width: $md) and (max-width: $lg) {
        //bottom: 20%;
        height: 35%;
      }
      @media only screen and (max-width: $md) {
        //margin-top: 0%;
        height: auto;
      }
      @media only screen and (max-width: $sm) {
        //margin-top: 0%;
        bottom: 0;
        height: 45%;
      }
      // flex
      position: absolute;
      bottom: 0;
      display: flex;
      // child styles
      color: #fff;
      //background: rgba(255, 255, 255, 1);
      background-image: url("~@/assets/images/img_lowest-prices-overlay.png"),
        linear-gradient(to right, #fff 50%, #c10230 50%);
      background-size: 100% 100%;
      .sliderLink {
        // Mobile
        @media only screen and (max-width: $md) {
          width: 100%;
        }
        flex-basis: 50%;
        // flex
        height: 100%;
        display: flex;
        flex-direction: column;
        //align-items: center;
        //justify-content: space-evenly;
        //width: 50%;
        h4 {
          color: #002d74;
          font-family: "BertholdCondensed";
          font-weight: 700;
          font-size: 45.36px;
          letter-spacing: 0;
          line-height: 36.29px;
          text-transform: uppercase;
          text-align: left;
          width: 114px;
          padding: 0 0 0 0;
          margin: 0.1em 0 0 0.4em;
          @media only screen and (min-width: $md) and (max-width: $lg) {
            font-size: 50px;
            width: 130px;
            line-height: 40px;
            margin: auto 0 auto 0.4em;
          }
          @media only screen and (max-width: $md) {
            text-align: center;
            align-self: center;
            width: 60%;
            margin: 0;
            font-size: 30px;
          }
        }
        span {
          color: #259ef3;
        }
        h3 {
          font-family: "BertholdCondensed";
          font-weight: 700;
          font-size: 25px;
          line-height: 20px;
          text-transform: uppercase;
          text-align: left;
          width: 200px;
          margin-top: 10%;
          padding: 0 1em;

          @media only screen and (max-width: $md) {
            padding: 0;
            width: 25%;
            margin: auto 0;
          }
        }
        .link-line-break {
          background-color: #fff;
          width: 90%;
          height: 1px;
          margin: 1em auto;
        }
        .link-desc {
          font-size: 14px;
          font-weight: 400;
          text-align: left;
          @media only screen and (min-width: 1578px) {
            font-size: 16px;
            padding: 5% 20% 5% 8%;
          }
          @media only screen and (min-width: $xl) {
            padding: 5% 1.5em;
          }
          @media only screen and (max-width: $xl) {
            padding: 5% 10% 0;
          }
          @media only screen and (max-width: $lg) {
            padding: 0 15% 0 5%;
            font-size: 18px;
            line-height: 1.5;
          }
          @media only screen and (max-width: $md) {
            padding: 0 0;
            width: 50%;
          }
          @media only screen and (max-width: $sm) {
            margin-bottom: 0;
            font-size: 13px;
          }
        }
      }
      #sliderLink1 {
        margin: auto 0;
        @media only screen and (max-width: $md) {
          justify-content: space-between;
        }
        .stars {
          width: 85%;
          margin: 0.5em auto;
          @media only screen and (max-width: $md) {
            width: 50%;
          }
        }
        #star1 {
          @media only screen and (max-width: $sm) {
            margin-top: 20px;
          }
        }
      }
      #sliderLink2 {
        @media only screen and (min-width: $md) and (max-width: $lg) {
          justify-content: space-between;
        }
        @media only screen and (max-width: $md) {
          //padding-top: 25px;
          #link2-text {
            display: flex;
            justify-content: space-evenly;
            margin: auto 0;
          }
        }
      }
    }
  }
  .swiper-wrapper {
    .swiper-slide {
      position: relative;
      img {
        object-fit: cover;
        object-position: 50% 50%;
        height: calc(100vw / 16 * 8);
        width: 100vw;
        @media only screen and (max-width: 1090px) {
          height: calc(90vh);
          //width: auto;
          object-position: 50% 0%;
        }
      }
      .sliderCaption {
        position: absolute;
        right: 2%;
        bottom: 3%;
        display: flex;
        align-items: center;
        z-index: 10;
        p {
          font-family: "BertholdCondensed";
          font-size: 15px;
          font-weight: 700;
          color: #fff;
          margin: 0;
        }
        .caption-line {
          height: 1.25em;
          width: 2px;
          background-color: #fff;
          margin: 0 0 0 4px;
        }
      }
      .vignette {
        height: 100%;
        width: 25%;
      }
      .vignette.vignette-left {
        position: absolute;
        top: 50%;
        left: 0;
        transform: translate(0, -50%);
        background-image: linear-gradient(
          270deg,
          rgba(4, 12, 24, 0),
          rgba(4, 12, 24, 0.7)
        );
      }
      .vignette.vignette-right {
        position: absolute;
        top: 50%;
        right: 0;
        transform: translate(0, -50%);
        background-image: linear-gradient(
          90deg,
          rgba(4, 12, 24, 0),
          rgba(4, 12, 24, 0.7)
        );
      }
      .blue-overlay {
        height: 100%;
        width: 100%;
        position: absolute;
        top: 50%;
        right: 0;
        transform: translate(0, -50%);
        background-color: rgba(4, 12, 24, 0.6);
      }
    }
  }
}
// Swiper Buttons

// Swiper Pagination
.swiper-pagination {
  .swiper-pagination-bullet {
    width: 8px;
    height: 8px;
    transform: rotate(45deg);
    display: inline-block;
    background: #000;
    opacity: 0.2;
  }
}
</style>
